<template>
  <bottom-bar backgroundColor="white">
    <v-container class="py-3 d-flex align-center justify-end">
      <v-btn fab small depressed class="primary lighten-1" @click="cartQuantity--" :disabled="disabled || cartQuantity === 1 || min >= cartQuantity">
        <v-icon class="transparent">mdi-minus</v-icon>
      </v-btn>
      <span class="mx-3 font-weight-bold text-subtitle-2 primary--text text--darken-1 fix-num-width">{{ cartQuantity >= min ? cartQuantity : min }}</span>
      <v-btn fab small depressed class="primary lighten-2" @click="cartQuantity++" :disabled="disabled"><v-icon class="transparent">mdi-plus</v-icon></v-btn>
      <v-btn color="primary" class="ml-10 px-10 d-block rounded-pill green-gradient-right text-capitalize" @click="handleAddToCart" :disabled="disabled">{{ $t('label.addToCart') }}</v-btn>
    </v-container>
  </bottom-bar>
</template>

<script>
export default {
  props: {
    addToCartHandler: {
      type: Function
    },
    quantity: {
      required: true
    },
    min: {
      required: true
    },
    disabled: {
      required: true
    }
  },

  data() {
    return {
      cartQuantity: this.quantity
    }
  },
  watch: {
    quantity: function (newVal, oldVal) {
      this.cartQuantity = newVal
    }
  },
  computed: {
    // ...mapState("shoppingCart", ["shoppingCart"]),
    // cartQuantity() {
    //   console.log('quantity bar', this.quantity)
    //   return this.quantity
    // }
  },

  methods: {
    // ...mapMutations("shoppingCart", ["REMOVE_CART_ITEM"]),
    decrement() {
      this.cartQuantity > 0 && this.cartQuantity--
    },
    handleAddToCart() {
      this.$emit('add-to-cart', this.cartQuantity)
    }
  }
}
</script>
